module.exports = __webpack_public_path__ + "img/ipadTheme.572b3eb0.svg";